export interface ToasterConfig {
  type: ToasterType;
  message: string;
  secondMessage: string[],
  isVisible: boolean;
  visibleOnNextPage: boolean;
}

export enum ToasterType {
  Green = 'green',
  Red = 'red',
}

export interface ToasterConfigUpdate {
  type: ToasterType;
  message: string;
  secondMessage?: string[],
  isVisible?: boolean;
  visibleOnNextPage?: boolean;
}
